angular.module('impactx.tax').controller('TaxEventListCtrl', [
    'selectedListItems',
    TaxEventListCtrl
]);

function TaxEventListCtrl(selectedListItems) {
    var self = this;

    self.getDetailLink = function () {
        return 'taxevent/' + selectedListItems.getFirstSelectedId();
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditTaxes'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/tax/templates/taxeventlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/tax/taxevent/list',
        id: "TaxEventList",
        excelExport: true,
        buttonDefinition: buttonDefinition,
        mainAction: {id: "new", link: "#/taxevent/0", icon: "mdi-plus"}
    };
    self.getMeta = function () {
        return self.meta;
    };
}